import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL as string;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Environment variables:', {
    supabaseUrl,
    supabaseAnonKey: supabaseAnonKey ? 'present' : 'missing',
    allEnv: process.env
  });
  throw new Error(
    `Missing Supabase environment variables. Please check your .env file.\n` +
    `REACT_APP_SUPABASE_URL: ${supabaseUrl ? 'present' : 'MISSING'}\n` +
    `REACT_APP_SUPABASE_ANON_KEY: ${supabaseAnonKey ? 'present' : 'MISSING'}`
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
